import {useEffect, useState} from 'react'
import {Collapse, Flex, List, ListIcon, ListItem, Text} from '@chakra-ui/react'
import {MdOutlineCircle} from 'react-icons/md'
import {BlogPostSectionsDynamicZone, Maybe,} from '_app/graphql/cms/generated/graphql'
import {ChevronDownIcon} from '@chakra-ui/icons'
import StringHelper from '../../../helpers/StringHelper/StringHelper'
import {useTranslation} from 'next-i18next'

type Props = {
    sections: Maybe<Array<Maybe<BlogPostSectionsDynamicZone>>>;
};

const Contents = ({sections}: Props) => {
    const { t } = useTranslation('blog')
    const [contents, setContents] = useState<string[]>([])
    const [showContents, setShowContents] = useState(false)
    const handleClick = (content: string) => {
        const matchingElements = Array.from(
            document.querySelectorAll('h2')).filter(a => a?.textContent?.includes(content)
        )
        const navHeight = document.querySelector('nav')?.clientHeight ?? 0
        const element = matchingElements?.[0]
        if (element) {
            window.scrollTo({top: element.getBoundingClientRect().top + window.scrollY - navHeight, behavior: 'smooth'})
        }
    }
    const toggleContents = () => setShowContents(!showContents)
    useEffect(() => {
        if (typeof window !== 'undefined' && sections) {
            const aggr: string[] = []
            const h2 = StringHelper.parseStringToObjectHTML(sections)?.getElementsByTagName('h2')
            if (h2) {
                Array.from(h2)?.forEach(el => el.innerText?.length > 0 && aggr.push(el.innerText))
            }
            setContents(aggr as string[])
        }
    }, [sections])
    return (
        <Flex flexDir="column" gap="0.5rem">
            {
                contents?.length > 0 && (
                    <>
                        <Text as="h4" textStyle="h4" onClick={toggleContents} cursor="pointer" sx={{ marginTop: '24px' }}>
                            <ChevronDownIcon transform={showContents ? 'rotate(0deg)' : 'rotate(-90deg)'}/> {t('CONTENTS')}
                        </Text>
                        <Collapse in={showContents}>
                            <List>
                                {contents?.map((content, index) => (
                                    <ListItem
                                        key={index}
                                        color="#213a7b"
                                        display="flex"
                                        alignItems="center"
                                        cursor="pointer"
                                        onClick={() => handleClick(content)}
                                    >
                                        <ListIcon as={MdOutlineCircle}/>
                                        {content}
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </>
                )
            }
        </Flex>
    )
}

export default Contents
